module.exports = __webpack_public_path__ + "static/img/2.e229c20.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/VascularSystem/Meeting584/images/2.png
// module id = q235
// module chunks = 4